import Block from '../blots/block';
import Break from '../blots/break';

class TextLine extends Block {
  replace(target) {
    target.children.forEach((blot) => {
      if (blot instanceof Break) {
        blot.replaceWith(Parchment.create('text', ' '));
      }
    });
    super.replace(target);
  }
  
  insertAt(index, text, value) {
    if (typeof value !== 'undefined' && text === 'textBreak') {
      super.insertAt(index, '\n');
    } else {
      super.insertAt(index, text, value);
    }
  }
}

TextLine.blotName = 'textLine';
TextLine.tagName = 'textarea';

export default TextLine;
